import React, { useRef, useState } from "react";
import { Box, Button, Typography, TextField } from "@mui/material";
import { Link } from "react-router-dom";
import { useRedirectUrl } from "../../../../../hooks/Authorize";

import LogoImg from "../../../../../assets/logo.png";
import RHFTextField from "../../../../../components/rhf-textField";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import useWidth from "../../../../../hooks/useSize";
import { signInWithPopup, signOut } from "firebase/auth";
import {
  auth,
  facebookProvider,
  googleProvider,
} from "../../../../../utilities/firebase.config";
import { FcGoogle } from "react-icons/fc";
import { FacebookTwoTone } from "@mui/icons-material";
import {
  setCookie,
  clearCookie,
  getCookie,
} from "../../../../../utilities/cookies";
import { Divider } from "@mui/material";

const API_BASE_URL = "https://accounts.wurknest.com:6050/api";

const Register = () => {
  const width = useWidth();
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    firstName: Yup.string()
      .matches(/^[a-zA-Z]+$/, "Only alphabets are allowed")
      .min(2)
      .max(25)
      .required("Required Field"),
    lastName: Yup.string()
      .matches(/^[a-zA-Z]+$/, "Only alphabets are allowed")
      .min(2)
      .max(25)
      .required("Required Field"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, action) => {
      console.log(values);
      action.resetForm();
      console.log("here janu");
      localStorage.setItem("registerFirstScreen", JSON.stringify(values));

      navigate("/personal-details");
    },
  });

  const styles = {
    registerWrap: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      color: "#fff",
      height: "100dvh",
    },
    registerContent: {
      marginTop: "10px",
      maxWidth: width > 768 ? "448.8px" : "100%",
      height: width > 768 ? "600px" : "100%",
      border: width > 768 ? "1px solid #8C8C8C" : "none",
      borderRadius: width > 768 ? "12px" : "none",
      // boxShadow:
      //   width > 768 ? "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" : "none",
      px: "35px",
      py: "35px",
      backgroundColor: width > 768 ? "#121212" : null,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    formWrapper: {
      paddingTop: "0px",
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignContent: "space-between",
      flexDirection: "column",
    },
    heading: {
      fontSize: "24px",
      fontWeight: 600,
    },
    label: {
      fontSize: "16px",
      fontWeight: 400,
      color: "#f5f4f4",
      py: 1,
    },
    emailInputAdornment: {
      fontSize: "13px",
      color: "#605f5f",
      fontWeight: 600,
      letterSpacing: 0.8,
      pt: 0.5,
    },
    forgotPassword: {
      color: "#1470B6",
      fontWeight: 700,
      fontSize: "14px",
    },
    register: {
      color: "#1470B6",
      fontWeight: 700,
      fontSize: "14px",
      textDecoration: "none",
    },
    button: {
      textDecoration: "none",
      backgroundColor: "#1472b8",
      padding: "6px 16px",
      color: "#fff",
      borderRadius: "4px",
      fontSize: "0.875rem",
      fontWeight: 600,
      textTransform: "uppercase",
      "&:hover": {
        background: "#1472b8",
      },
    },
    desc: {
      fontSize: "16px",
      fontWeight: 600,
      color: "#7e7878",
      py: 1,
      px: 2,
    },
  };

  const [loadding, setLoadding] = useState(false);

  const [error, setError] = useState("");
  const [user, setUser] = useState(null);
  const [tokens, setTokens] = useState(null);
  const popupInProgress = useRef(false);
  const redirectUrl = useRedirectUrl();
  const generateRandomPassword = (length = 12) => {
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=";
    try {
      const randomValues = new Uint32Array(length);
      window.crypto.getRandomValues(randomValues);
      return Array.from(randomValues)
        .map((v) => charset[v % charset.length])
        .join("");
    } catch (e) {
      let res = "";
      for (let i = 0; i < length; i++) {
        res += charset[Math.floor(Math.random() * charset.length)];
      }
      return res;
    }
  };

  const withSuppressedFirebasePopupAssertion = async (fn) => {
    const handler = (ev) => {
      try {
        const r = ev.reason;
        const msg = r && (r.message || r.code || String(r));
        if (
          (typeof msg === "string" &&
            msg.includes("Pending promise was never set")) ||
          (r && r.code === "auth/popup-closed-by-user")
        ) {
          ev.preventDefault();
          console.warn(
            "Suppressed firebase unhandled rejection during popup:",
            r
          );
        }
      } catch (suppressErr) {}
    };

    window.addEventListener("unhandledrejection", handler);
    try {
      return await fn();
    } finally {
      window.removeEventListener("unhandledrejection", handler);
    }
  };
  const handleSocialLogin = async (provider) => {
    if (popupInProgress.current) {
      console.warn("Popup already in progress, ignoring duplicate click.");
      return;
    }
    popupInProgress.current = true;
    setLoadding(true);
    setError("");

    try {
      let result;
      let providerName;
      let authProvider;

      if (provider === "google") {
        authProvider = googleProvider;
        providerName = "google";
      } else if (provider === "facebook") {
        authProvider = facebookProvider;
        providerName = "facebook";
      } else {
        throw new Error("Invalid provider");
      }

      try {
        result = await withSuppressedFirebasePopupAssertion(() =>
          signInWithPopup(auth, authProvider)
        );
      } catch (firebaseErr) {
        console.error(
          "Firebase popup error:",
          firebaseErr?.code,
          firebaseErr?.message
        );
        if (
          firebaseErr?.code === "auth/popup-closed-by-user" ||
          firebaseErr?.code === "auth/cancelled-popup-request" ||
          firebaseErr?.code === "auth/popup-blocked"
        ) {
          console.log("Login cancelled by user");
          return;
        }
        throw firebaseErr;
      }

      const idToken = await result.user.getIdToken();

      const response = await fetch(`${API_BASE_URL}/auth/socialLogin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          idToken,
          provider: providerName,
          login_app: "Wurknest Accounts",
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Social login failed");
      }

      // Second API hit: Register/Sync user
      const randomPassword = generateRandomPassword(14);
      const displayName = result.user.displayName || "";
      const firstNameFromDisplay = displayName ? displayName.split(" ")[0] : "";
      const lastNameFromDisplay = displayName
        ? displayName.split(" ").slice(1).join(" ")
        : "";

      const signupData = {
        userName:
          (result.user.email
            ? result.user.email.split("@")[0]
            : firstNameFromDisplay.toLowerCase()) || "",
        firstName: firstNameFromDisplay || "",
        lastName: lastNameFromDisplay || "",
        email: result.user.email || "",
        password: randomPassword,
      };

      try {
        const regRes = await fetch(`https://api.projects.wurknest.com:6550/api/v2/auth/register`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(signupData),
        });
        const regData = await regRes.json();
        console.log("Register succeeded:", regData);
      } catch (regErr) {
        console.warn(
          "Register failed but continuing to redirect:",
          regErr.message || regErr
        );
      }

      if (data.success) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("sessionToken", data.sessionToken);
        localStorage.setItem("user", JSON.stringify(data.user));

        const currentUser = data.user;

        if (redirectUrl && redirectUrl !== "" && redirectUrl !== "null") {
          clearCookie("redirectto");
          return window.location.replace(
            redirectUrl +
              "userId=" +
              currentUser._id +
              "&refreshToken=" +
              data.refreshToken
          );
        } else {
          window.location.replace("https://wurknest.com/");
        }
      }
    } catch (error) {
      console.error("Social login error:", error);
      setError(error.message || "An error occurred during login");
      try {
        if (error?.code !== "auth/popup-closed-by-user") {
          await signOut(auth);
        }
      } catch (signOutError) {
        console.error("Sign out error:", signOutError);
      }
    } finally {
      setLoadding(false);
      popupInProgress.current = false;
    }
  };

  return (
    <Box sx={styles.registerWrap}>
      <Box sx={styles.registerContent}>
        <Box sx={{ textAlign: "center" }}>
          <Box sx={{ textAlign: "center" }}>
            <img
              src={LogoImg}
              alt="Logo"
              style={{ width: width > 768 ? "8%" : "12%" }}
            />
          </Box>
        </Box>
        <Box sx={{ pt: 2, textAlign: "center" }}>
          <Typography component="h2" sx={styles.heading}>
            Create A Wurknest Account
          </Typography>
          <Box display="flex" flexDirection="column" gap={2} width="100%">
            <Button
              fullWidth
              variant="outlined"
              disabled={loadding}
              onClick={() => handleSocialLogin("google")}
              startIcon={<FcGoogle size={22} />}
              sx={{
                borderRadius: "9999px",
                textTransform: "none",
                fontWeight: 500,
                py: { xs: 1, md: 1.5 },
                px: { xs: 1.5, md: 2 },
                fontSize: { xs: "0.875rem", md: "0.875rem" },
                color: "text.primary",
                "&:hover": {
                  bgcolor: "action.hover",
                },
              }}
            >
              Continue with Google
            </Button>

            <Button
              fullWidth
              variant="outlined"
              disabled={loadding}
              onClick={() => handleSocialLogin("facebook")}
              startIcon={<FacebookTwoTone sx={{ color: "#1877f2" }} />}
              sx={{
                borderRadius: "9999px",
                textTransform: "none",
                fontWeight: 500,
                py: { xs: 1, md: 1.5 },
                px: { xs: 1.5, md: 2 },
                fontSize: { xs: "0.875rem", md: "0.875rem" },
                color: "text.primary",
                "&:hover": {
                  bgcolor: "action.hover",
                },
              }}
            >
              Continue with Facebook
            </Button>

            <Box display="flex" alignItems="center" width="100%" my={2}>
              <Box flexGrow={1}>
                <Divider />
              </Box>
              <Typography
                variant="body2"
                sx={{ mx: { xs: 1.5, md: 2 }, color: "text.secondary" }}
              >
                OR
              </Typography>
              <Box flexGrow={1}>
                <Divider />
              </Box>
            </Box>
          </Box>
          <Typography component="h4" sx={styles.label}>
            Enter your name
          </Typography>

          <form onSubmit={formik.handleSubmit} style={styles.formWrapper}>
            <Box>
              <RHFTextField
                formik={formik}
                name="firstName"
                type="text"
                placeholder="First Name"
                controlSx={{ pt: 2 }}
              />
              <RHFTextField
                formik={formik}
                name="lastName"
                type="text"
                placeholder="Last Name"
                controlSx={{ pt: 2 }}
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  pt: 2.8,
                }}
              >
                <Link to="/login" style={styles.register}>
                  {width > 768 ? "Already have an account? Sign in" : "Sign in"}
                </Link>
                <Button sx={styles.button} type="submit">
                  Next
                </Button>
              </Box>
            </Box>
          </form>
        </Box>
      </Box>
      <Box sx={{ textAlign: "center", pt: 2 }}>
        <Typography component="p" sx={styles.desc}>
          Enter the AI realm with us, or join us with your login
        </Typography>
      </Box>
    </Box>
  );
};

export default Register;
